export const updateSidebarHeight = ( components, sidebarIndex ) => {
	const sidebar = components[sidebarIndex];
    let sidebarHeight = ``;
    let sidebarMarginBottom = ``;

    if ( document.documentElement.clientWidth >= 956 )
    {
        sidebarHeight = 0;
        let i;

        for ( i = sidebarIndex - 1; i < components.length; i++ )
        {
            if ( components[i].offsetWidth >= document.documentElement.clientWidth )
            {
                break;
            }
			
			const nextSidebar = components[i + 1];
			if ( nextSidebar && nextSidebar.closest( 'aside.sidebar' ) && nextSidebar !== sidebar )
			{
				break;
			}
        
            if ( components[i] !== sidebar )
            {
            	const css = getComputedStyle( components[i] );
                sidebarHeight += components[i].offsetHeight + parseFloat( css.marginBottom ) + parseFloat( css.marginTop );
            }
        }

        sidebarMarginBottom = `${(sidebarHeight - components[sidebarIndex - 1].offsetHeight) * -1}px`;
        sidebarHeight = `${sidebarHeight}px`;
    }

    sidebar.style.height = sidebarHeight;
    sidebar.style.marginBottom = sidebarMarginBottom;
};
